import { inject, Injectable } from '@angular/core';
import { BrandingManagerService } from '@rx-applications/shared/branding/data-access';
import { Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class MetaTagsService {
  #brandingManagerService = inject(BrandingManagerService)
  #meta = inject(Meta)

  setThemeMetaTag() {
    this.#meta.updateTag({ name: 'theme-color', content: this.#brandingManagerService.getBrandAccess().getMetaTagColor() });
  }
}
